/* Custom script to update the variant link and image when a product card color swatch is selected */
window.SwatchUpdater = window.SwatchUpdater || {
  initialized: false,
  selectors: {
    group: '.card__swatches-custom',
    input: 'input[type="radio"]',
    card: '.product-card-wrapper',
    img: '.card__media img',
  },

  init(context = document) {
    const groups = context.querySelectorAll(this.selectors.group);
    if (!groups.length) return;

    groups.forEach((swatchGroup) => {
      if (swatchGroup.dataset.swatchBound === 'true') return;
      swatchGroup.dataset.swatchBound = 'true';

      swatchGroup.addEventListener('change', (event) => {
        const input = event.target;
        if (!input.matches(this.selectors.input)) return;

        const card = input.closest(this.selectors.card);
        if (!card) return;

        const img = card.querySelector(this.selectors.img);
        const newSrcset = input.dataset.variantSrcset;
        const newSrc = (newSrcset || '').split(',').pop()?.trim().split(' ')?.[0];
        const newUrl = input.dataset.variantUrl;

        if (img && newSrc && newSrcset) {
          img.src = newSrc;
          img.srcset = newSrcset;
        }

        if (newUrl) {
          const baseProductUrl = card.dataset.productUrl;
          card.querySelectorAll(`a[href^="${baseProductUrl}"]`).forEach((link) => {
            link.href = newUrl;
          });
        }
      });
    });
  }
};

// Initial run
document.addEventListener('DOMContentLoaded', () => {
  SwatchUpdater.init();

  // Set up MutationObserver to catch dynamically added product cards
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          if (node.matches && node.matches(SwatchUpdater.selectors.group)) {
            SwatchUpdater.init(node);
          } else if (node.querySelector && node.querySelector(SwatchUpdater.selectors.group)) {
            SwatchUpdater.init(node);
          }
        }
      });
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});